if (!customElements.get('dl-variant-weight')) {
  class DLVariantWeight extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('[id^="ProductInfo-"]');
      this.onSelection = () => this.update();
      this.scope?.addEventListener('change', this.onSelection);
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onSelection);
    }
    normalize(value) {
      const text = String(value || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, '').replace(',', '.');
      const metres = text.match(/^(\d+(?:\.\d+)?)m$/);
      return metres ? `${Number(metres[1]) * 100}cm` : text;
    }
    update() {
      const output = this.querySelector('p');
      const template = this.querySelector('template');
      if (!output || !template) return;
      const rows = Array.from(template.content.querySelectorAll('tr'));
      const headers = rows[0] ? Array.from(rows[0].children, cell => this.normalize(cell.textContent)) : [];
      const weightIndex = headers.findIndex(header => /^(vikt|weight|produktvikt|productweight)(\(g\)|\(kg\))?$/.test(header));
      const neckIndex = headers.findIndex(header => /halsomf|halsomk|nacke|neck/.test(header));
      const chestIndex = headers.findIndex(header => /bröst|chest/.test(header));
      const choices = Array.from(this.scope?.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select') || []);
      let keys = headers.map((header, index) => /^(storlek|size|längd|length|totallängd|totallength)/.test(header) ? index : -1).filter(index => index >= 0 && index !== weightIndex);
      if (!keys.length) keys = [0];
      const row = rows.slice(1).find(row => keys.every(index => choices.some(input => this.normalize(input.value) === this.normalize(row.children[index]?.textContent))));
      let value = ''; 
      if (weightIndex > 0) {
        value = row?.children[weightIndex]?.textContent.trim() || '';
        if (/^\d+(?:[.,]\d+)?$/.test(value)) {
          if (headers[weightIndex].endsWith('(g)')) value += ' g';
          if (headers[weightIndex].endsWith('(kg)')) value += ' kg';
        }
        const measuredWeight = value.match(/^(\d+(?:[.,]\d+)?)\s*(g|kg|gram|grams)?$/i);
        if (!measuredWeight || Number(measuredWeight[1].replace(',', '.')) <= 0) value = '';
      }
      const measure = index => {
        const text = row?.children[index]?.textContent.trim().replace(/\s*[-–—]\s*/g, '–') || '';
        return /\d/.test(text) ? (/(cm|mm)$/i.test(text) ? text : `${text} cm`) : '';
      };
      const neck = neckIndex > 0 ? measure(neckIndex) : '';
      const chest = chestIndex > 0 ? measure(chestIndex) : '';
      const parts = [];
      if (neck) parts.push(`${this.dataset.neckLabel} ${neck}`);
      if (chest) parts.push(`${this.dataset.chestLabel} ${chest}`);
      if (value) parts.push(`${this.dataset.label.toLowerCase()} ${value}`);
      output.hidden = !parts.length;
      output.textContent = parts.join(', ');
      const sizeChoice = choices.find(input => keys.some(index => this.normalize(input.value) === this.normalize(row?.children[index]?.textContent)));
      const anchor = sizeChoice?.closest('fieldset');
      const container = this.parentElement;
      const guide = anchor?.querySelector('.dl-size-guide-below');
      if (guide && guide.previousElementSibling !== container) guide.before(container);
      else if (anchor && !guide && anchor.nextElementSibling !== container) anchor.after(container);
    }
  }
  customElements.define('dl-variant-weight', DLVariantWeight);
}
